<div>
	<p>Deleting a Fine Group Action will NOT remove fines from the students it has been assigned to.</p>
	<p>Only the reference in the fine to this Group Action will be removed.?</p>
	<p>Are you sure you wish to Delete this?</p>
</div>

<div class="Buttons">
	<button class="btn btn-primary" (click)="onYes()">Yes</button>
	<button class="btn btn-primary" (click)="onNo()">No</button>
</div>
